export default [
    {
        path: '/app/mansong/list.html',
        component: (resolve) => require(['@/view/app/mansong/index.vue'],resolve),
    },
    {
        path: '/app/mansong/add.html',
        component: (resolve) => require(['@/view/app/mansong/add.vue'],resolve),
    },
]
